import { render, staticRenderFns } from "./SecurityChangePass.vue?vue&type=template&id=b161ff5e"
import script from "./SecurityChangePass.vue?vue&type=script&lang=js"
export * from "./SecurityChangePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports